/* ============================================================
   TAKEOVER CONFERENCE THEME — theme.js
   AJAX cart drawer · countdown · reveals · variants
   ============================================================ */
(function () {
  'use strict';
  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const money = (cents) =>
    (window.Shopify && Shopify.currency ? '' : '') +
    '$' + (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2 });

  /* ---------- HEADER SCROLL ---------- */
  const head = $('.site-head');
  if (head) {
    const onScroll = () => head.setAttribute('data-scrolled', window.scrollY > 30);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- MOBILE MENU ---------- */
  const burger = $('.burger');
  const mobileMenu = $('.mobile-menu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', () => {
      const open = mobileMenu.getAttribute('data-open') === 'true';
      mobileMenu.setAttribute('data-open', String(!open));
      burger.setAttribute('data-open', String(!open));
      document.body.style.overflow = open ? '' : 'hidden';
    });
    $$('.mobile-menu a').forEach((a) =>
      a.addEventListener('click', () => {
        mobileMenu.setAttribute('data-open', 'false');
        burger.setAttribute('data-open', 'false');
        document.body.style.overflow = '';
      })
    );
  }

  /* ---------- SCROLL REVEAL ---------- */
  const io = new IntersectionObserver(
    (entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }),
    { threshold: 0.12 }
  );
  $$('[data-reveal]').forEach((el, i) => { el.style.transitionDelay = (i % 6) * 60 + 'ms'; io.observe(el); });

  /* ---------- COUNTDOWN ---------- */
  $$('[data-countdown]').forEach((node) => {
    const target = new Date(node.getAttribute('data-countdown')).getTime();
    const dEl = $('[data-cd="days"]', node), hEl = $('[data-cd="hours"]', node),
          mEl = $('[data-cd="mins"]', node), sEl = $('[data-cd="secs"]', node);
    const pad = (n) => String(Math.max(0, n)).padStart(2, '0');
    const tick = () => {
      const diff = target - Date.now();
      if (diff <= 0) { if (dEl) dEl.textContent = '00'; if (hEl) hEl.textContent = '00'; if (mEl) mEl.textContent = '00'; if (sEl) sEl.textContent = '00'; return; }
      const d = Math.floor(diff / 864e5), h = Math.floor((diff % 864e5) / 36e5),
            m = Math.floor((diff % 36e5) / 6e4), s = Math.floor((diff % 6e4) / 1e3);
      if (dEl) dEl.textContent = pad(d); if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m); if (sEl) sEl.textContent = pad(s);
    };
    tick(); setInterval(tick, 1000);
  });

  /* ============================================================
     CART DRAWER (AJAX)
     ============================================================ */
  const scrim = $('.drawer-scrim');
  const drawer = $('.drawer');
  const FREE_SHIP = (window.TKO && window.TKO.freeShip) || 0; // cents; 0 = disabled

  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'true');
    scrim.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'false');
    scrim.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
  }
  $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); }));
  $$('[data-cart-close]').forEach((b) => b.addEventListener('click', closeDrawer));
  if (scrim) scrim.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  function renderCart(cart) {
    const count = cart.item_count;
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.style.display = count ? 'grid' : 'none'; });

    const itemsWrap = $('[data-cart-items]');
    const footEl = $('[data-cart-foot]');
    if (!itemsWrap) return;

    if (!count) {
      itemsWrap.innerHTML =
        '<div class="drawer__empty"><p class="eyebrow" style="justify-content:center">Your bag is empty</p>' +
        '<p style="color:var(--smoke)">Gear up before the Takeover. Limited drops, limited time.</p>' +
        '<a class="btn btn--ghost" href="/collections/all" data-cart-close>Shop the drop</a></div>';
      if (footEl) footEl.style.display = 'none';
      $$('[data-cart-close]', itemsWrap).forEach((b) => b.addEventListener('click', closeDrawer));
      return;
    }
    if (footEl) footEl.style.display = 'block';

    itemsWrap.innerHTML = cart.items.map((it) => `
      <div class="line-item" data-key="${it.key}">
        <img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x200$1$2') : ''}" alt="${it.product_title}">
        <div>
          <div class="line-item__t">${it.product_title}</div>
          ${it.variant_title && it.variant_title !== 'Default Title' ? `<div class="line-item__v">${it.variant_title}</div>` : ''}
          <div class="qty">
            <button data-qty-down aria-label="Decrease">–</button>
            <span>${it.quantity}</span>
            <button data-qty-up aria-label="Increase">+</button>
          </div><br>
          <a class="line-item__rm" data-remove>Remove</a>
        </div>
        <div class="line-item__price">${money(it.final_line_price)}</div>
      </div>`).join('');

    const subEl = $('[data-cart-subtotal]');
    if (subEl) subEl.textContent = money(cart.total_price);

    // free-ship progress
    const bar = $('[data-ship-fill]'), txt = $('[data-ship-txt]');
    if (bar && FREE_SHIP > 0) {
      const pct = Math.min(100, (cart.total_price / FREE_SHIP) * 100);
      bar.style.width = pct + '%';
      const left = FREE_SHIP - cart.total_price;
      txt.textContent = left > 0 ? `You're ${money(left)} away from free shipping` : 'Free shipping unlocked ✦';
    }

    // bind qty + remove
    $$('.line-item', itemsWrap).forEach((row) => {
      const key = row.getAttribute('data-key');
      const qtySpan = $('.qty span', row);
      const q = parseInt(qtySpan.textContent, 10);
      $('[data-qty-up]', row).addEventListener('click', () => updateItem(key, q + 1));
      $('[data-qty-down]', row).addEventListener('click', () => updateItem(key, q - 1));
      $('[data-remove]', row).addEventListener('click', () => updateItem(key, 0));
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  }
  function updateItem(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    }).then((r) => r.json()).then(renderCart);
  }

  // AJAX add-to-cart (any form with data-cart-form)
  $$('[data-cart-form], form.product-form').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = $('[type="submit"]', form);
      const original = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then((r) => r.json())
        .then(() => fetchCart())
        .then((cart) => { renderCart(cart); openDrawer(); })
        .catch(() => {})
        .finally(() => { if (btn) { btn.textContent = original; btn.disabled = false; } });
    });
  });

  // initial paint
  if (drawer) fetchCart().then(renderCart);

  /* ============================================================
     PRODUCT PAGE — variants, gallery, options
     ============================================================ */
  const pdp = $('[data-pdp]');
  if (pdp) {
    let variants = [];
    try { variants = JSON.parse($('[data-variants]', pdp).textContent); } catch (e) {}
    const selected = {};
    const idInput = $('[data-variant-id]', pdp);
    const priceEl = $('[data-pdp-price]', pdp);
    const addBtn  = $('[data-add-btn]', pdp);

    function currentVariant() {
      return variants.find((v) =>
        v.options.every((opt, i) => selected['option' + (i + 1)] === opt)
      );
    }
    function syncVariant() {
      const v = currentVariant();
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (addBtn) {
        const labelDefault = addBtn.getAttribute('data-label-default') || 'Add to bag';
        const labelSold = addBtn.getAttribute('data-label-soldout') || 'Sold out';
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? labelDefault : labelSold;
      }
      // swap main image if variant has featured media
      if (v.featured_image && v.featured_image.src) {
        const main = $('[data-pdp-main]', pdp);
        if (main) main.src = v.featured_image.src;
      }
    }
    $$('[data-option]', pdp).forEach((group) => {
      const idx = group.getAttribute('data-option');
      $$('[data-value]', group).forEach((btn) => {
        if (btn.getAttribute('aria-pressed') === 'true') selected['option' + idx] = btn.getAttribute('data-value');
        btn.addEventListener('click', () => {
          $$('[data-value]', group).forEach((b) => b.setAttribute('aria-pressed', 'false'));
          btn.setAttribute('aria-pressed', 'true');
          selected['option' + idx] = btn.getAttribute('data-value');
          syncVariant();
        });
      });
    });
    syncVariant();

    // thumbnail gallery
    $$('[data-thumb]', pdp).forEach((t) => {
      t.addEventListener('click', () => {
        const main = $('[data-pdp-main]', pdp);
        if (main) main.src = t.getAttribute('data-full');
        $$('[data-thumb]', pdp).forEach((x) => x.setAttribute('aria-current', 'false'));
        t.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---------- COLLECTION SORT ---------- */
  const sortSel = $('[data-sort]');
  if (sortSel) {
    sortSel.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSel.value);
      window.location.href = url.toString();
    });
  }
})();
